<template>
  <div>
    <el-dialog :title="form.id?'编辑章节':'新增章节'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="章节节数：" prop="chaptersNum" class="width100">
          <el-input v-model="form.chaptersNum" placeholder="请输入章节节数" />
        </el-form-item>
        <el-form-item label="章节名称：" prop="name" class="width100">
          <el-input v-model="form.name" placeholder="请输入章节名称" />
        </el-form-item>
        <el-form-item label="封面图：" class="width100">
          <div class="flexs">
            <imageUpload v-model="form.coverImage" width="32" height="32" />
            <span class="hint hint1">限制上传1张<br />建议尺寸260x168像素以上</span>
          </div>
        </el-form-item>
        <el-form-item label="课程课：" prop="videoUrlArr" class="width100">
          <fileUpload v-model="form.videoUrlArr" @input="getVideoDuration" />
        </el-form-item>
        <el-form-item label="课程时长(s)：" prop="duration" class="width100">
          <el-input v-model="form.duration" placeholder="请输入课程时长" />
        </el-form-item>
        <el-form-item label="状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch> {{form.state?'启用':'禁用'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import courseSubjectVideoApi from '@/api/course/courseSubjectVideo'
import FileUpload from "@/components/FileUpload"
import ImageUpload from "@/components/ImageUpload";
import Editor from "@/components/Editor";
function initFormBean() {
  const formBean = {
    chaptersNum: null,
    name: null,
    coverImage: null,
    duration: null,
    videoUrlArr: [],
    state: 1,
  }
  return formBean
}

export default {
  props: ['rowItem'],
  components: { Editor, ImageUpload, FileUpload },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        chaptersNum: [{ required: true, message: '请输入章节节数', trigger: 'blur' },
        { pattern: /^[1-9]\d*$/, message: '必须为数字值', trigger: 'blur' }],
        name: [{ required: true, message: '请输入章节名称', trigger: 'blur' }],
        duration: [{ required: true, message: '请输入课程时长', trigger: 'blur' },
        { pattern: /^[1-9]\d*$/, message: '必须为数字值', trigger: 'blur' }],
        videoUrlArr: [{ required: true, message: '请上传课程课', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(total) {
      this.resetForm()
      this.$set(this.form, 'chaptersNum', total + 1)
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      if (row.videoUrl) {
        this.$set(this.form, 'videoUrlArr', [{ url: row.videoUrl, name: row.videoUrl }])
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcParams() {
      this.form.subjectId = this.rowItem.id;
      let params = JSON.parse(JSON.stringify(this.form));
      if (params.videoUrlArr.length > 0) {
        params.videoUrl = params.videoUrlArr[0].url
      }
      delete params.videoUrlArr
      params.chaptersNum = +params.chaptersNum || ''
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          if (this.isRepSub) return
          this.isRepSub = true
          if (params.id > 0) {
            courseSubjectVideoApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseSubjectVideoApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }

        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    getVideoDuration(value) {
      if (value && value.length > 0) {
        var audio = new Audio(value[0].url)
        audio.addEventListener('loadedmetadata', () => {
          //返回的是 秒 格式的时间
          this.form.duration = parseInt(audio.duration)
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
